import { ReactElement, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'

import { RouteProp } from '@/propTypes'
import { MenuButton } from '../../atoms'

import env from '@/lib/env'

import Container from './style'
import { useHooks } from './methods'

interface Props {
  routes: Route[]
  onPress?: () => void
  style?: CSSProperties
  className?: string
  id?: string
}

function NavigatorGroup({
  id,
  className,
  style,
  routes,
  onPress,
}: Props): ReactElement {
  const { nextRoute } = useHooks()

  return (
    <Container id={id} className={className} style={style}>
      {routes.map((route: Route) => (
        <MenuButton
          key={`${route.pathname}-${route.hash}`}
          href={route.pathname}
          hash={route.hash}
          isSelected={nextRoute.pathname === route.pathname}
          onPress={onPress}
        >
          {route.name}
        </MenuButton>
      ))}
      <MenuButton href={env.PLATFORM_URL} onPress={onPress} isExternal>
        เข้าสู่ระบบ
      </MenuButton>
    </Container>
  )
}

NavigatorGroup.propTypes = {
  onPress: PropTypes.func,
  routes: PropTypes.arrayOf(RouteProp).isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

NavigatorGroup.defaultProps = {
  className: '',
}

export default memo(NavigatorGroup)
